/** Konfig pre minihru celkovo */
export const minigameConfig = {
    /** hodnota, ktora sa bude davat, ked hrac nedojde do ciela */
    dnfValue: 999999999999,
    /** hodnota, ktora sa bude davat, ked bude hrac diskvalifikovany */
    dsqValue: 9999999999999,
    /** Honodta pre DNS, ked sa vysledky pocitaju od najnizsieho */
    dnsValueAscending: 99999999999999,
    /** Honodta pre DNS, ked sa vysledky pocitaju od najvyssieho */
    dnsValueDescending: -1,
    /** defaultna rychlost animacii */
    defaultAnimationSpeed: 1,
    /** max timestamp pre porovnavacky */
    maxTimestamp: 8640000000000000,
    /** Limit pre fpska */
    fpsLimit: 30
};
//# sourceMappingURL=minigameConfig.js.map